module.exports = __webpack_public_path__ + "static/media/img14.4a74544d.jpeg";